// Types for the enriched hotel model (Exigences 3.1 à 3.10)
import type { HotelRestaurant } from './restaurant';

export interface HotelEnriched {
  id?: string;
  name: string;
  // Identification (3.1)
  commercial_name: string;
  legal_name: string;
  establishment_type: string;
  star_category: number | null;
  status: string;
  tourism_approval_number: string;
  rccm: string;
  nif: string;
  cnss: string;
  legal_form: string;
  email: string;
  // Localisation (3.2)
  province: string;
  city: string;
  commune: string;
  quartier: string;
  full_address: string;
  address: string;
  latitude: number | null;
  longitude: number | null;
  // Gestion et Contacts (3.3)
  owner_name: string;
  owner_phone: string;
  manager_name: string;
  manager_phone: string;
  manager_email: string;
  operational_manager_name: string;
  operational_manager_phone: string;
  operational_manager_email: string;
  // Exploitation (3.4)
  total_rooms: number | null;
  num_suites: number;
  num_beds: number;
  num_conference_rooms: number;
  // Services/Commodités (3.5)
  has_parking: boolean;
  has_pool: boolean;
  has_gym: boolean;
  has_wifi: boolean;
  has_restaurant: boolean;
  has_bar: boolean;
  has_ac: boolean;
  has_room_service: boolean;
  has_generator: boolean;
  has_cctv: boolean;
  // RH (3.6)
  male_employees: number;
  female_employees: number;
  hr_manager_name: string;
  hr_manager_phone: string;
  security_agents: number;
  // Fiscalité (3.7)
  is_fpt_subject: boolean;
  fpt_rate: number;
  payment_methods: string[];
  // Sécurité et Conformité (3.8)
  has_client_register: boolean;
  has_police_form: boolean;
  has_id_scanner: boolean;
  has_access_control: boolean;
  has_visitor_log: boolean;
  // Métadonnées (3.9)
  data_source: string;
  registered_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
  // Relations
  restaurants?: HotelRestaurant[];
}

export type HotelEnrichedErrors = Partial<Record<keyof HotelEnriched, string>>;

export function createEmptyHotelEnriched(): HotelEnriched {
  return {
    name: '', commercial_name: '', legal_name: '', establishment_type: '',
    star_category: null, status: 'active', tourism_approval_number: '',
    rccm: '', nif: '', cnss: '', legal_form: '', email: '',
    province: '', city: '', commune: '', quartier: '', full_address: '', address: '',
    latitude: null, longitude: null,
    owner_name: '', owner_phone: '', manager_name: '', manager_phone: '',
    manager_email: '', operational_manager_name: '', operational_manager_phone: '',
    operational_manager_email: '',
    total_rooms: null, num_suites: 0, num_beds: 0, num_conference_rooms: 0,
    has_parking: false, has_pool: false, has_gym: false, has_wifi: false,
    has_restaurant: false, has_bar: false, has_ac: false, has_room_service: false,
    has_generator: false, has_cctv: false,
    male_employees: 0, female_employees: 0, hr_manager_name: '', hr_manager_phone: '',
    security_agents: 0,
    is_fpt_subject: true, fpt_rate: 4.0, payment_methods: [],
    has_client_register: false, has_police_form: false, has_id_scanner: false,
    has_access_control: false, has_visitor_log: false,
    data_source: 'manual',
  };
}
